import React, { useState } from "react";
import { BrowserRouter, Switch, Redirect } from "react-router-dom";
import {
  AddBookScreen,
  AgreementScreen,
  ArticleReadScreen,
  ArticlesScreen,
  AuthorBookScreen,
  AuthorSubmissionsScreen,
  CheckoutEbookScreen,
  CheckoutWithAddressScreen,
  CompanyScreen,
  FeaturedPublicationScreen,
  FuturePublicationsScreen,
  HomeScreen,
  ReadBookScreen,
} from "./views";
import { BookScreen, CartScreen, CheckoutScreen, ShopScreen } from "./views";
import { DashboardScreen, LoginScreen, SignUpScreen } from "./views";
import { RouteWithLayout } from "./components";
import { MainLayout, MinimalLayout } from "./layout";
import PreOrder from "./views/PreOrder/PreOrder";
import ShoppingCart from "./views/ShoppingCart/ShoppingCart";
import AdminBook from "./views/AdminBook/AdminBook";
import ReadIndividualArticle from './views/Articles/ReadIndividualArticle';
import KleverBook from "./views/KleverBook/KleverBook";
import VerifyAccount from "./components/VerifyAccount/VerifyAccount";
import AdminBookDetail from "./views/AdverBook/components/AdminBookDetail";
import AddNewPaymentMethod from "./components/PaymentMethod/AddNewPaymentMethod"
import KleverBookDetail from "./views/AdverBook/components/KleverBookDetail";
import PaymentIntegration from "./views/PaymentIntegration/PaymentIntegration";
import MainCheckout from "./views/CartCheckout/MainCheckout";
import Contact from "./views/Contact";
import Pricing from "./views/Pricing";
import Sell from "./views/Sell";
import { MyContextProvider } from "./contextApi/context";

//Old Terms of Use
// import Terms from "./views/Terms";

//Old PrivacyPolicy
// import PrivacyPolicy from "./views/PrivacyPolicy";
import AdverBook from "./views/AdverBook";
import AddBookD2p from "./views/AddBook/AddBookD2p";
import LoanBooks from "./views/AdverBook/LoanBooks/LoanBooks";
import { AdverBookRead } from "./views/Dashboard/Customer/components";
import { BooksCatalog } from "./views/AdverBook/BooksCatalog";
import { useSelector } from "react-redux";

//NEW PrivacyPolicy
import PrivacyPolicy from "./components/PrivacyPolicy/Privacy";

//NEW Terms
import Termsofuse from "./components/Terms/Terms";
import PaymentMethodDetails from "./components/PaymentMethod/PaymentMethodDetails";

function Routes() {
  const { currentUser } = useSelector((state) => state.auth);
  return (
    <MyContextProvider>
      <BrowserRouter basename="/">
        <Switch>
          <RouteWithLayout
            path="/"
            exact
            component={HomeScreen}
            layout={MainLayout}
          />
          {/* <RouteWithLayout
          path="/e-book/reading"
          exact
          component={ReadBookScreen}
          layout={MainLayout}
        /> */}
        <RouteWithLayout
          path="/company"
          exact
          component={CompanyScreen}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/contact"
          exact
          component={Contact}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/sell"
          exact
          component={Sell}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/pricing"
          exact
          component={Pricing}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/terms"
          exact
          component={Termsofuse}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/privacy-policy"
          exact
          component={PrivacyPolicy}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/featured-publications"
          exact
          component={FeaturedPublicationScreen}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/author-submissions"
          exact
          component={AuthorSubmissionsScreen}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/future-publications"
          exact
          component={FuturePublicationsScreen}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/agreement"
          exact
          component={AgreementScreen}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/shop"
          exact
          component={ShopScreen}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/kleverbook"
          exact
          component={KleverBook}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/admin-book"
          exact
          component={AdminBook}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/admin-book/:bookId"
          exact
          component={AdminBookDetail}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/klever-book/:bookId"
          exact
          component={KleverBookDetail}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/payment-integration"
          exact
          component={PaymentIntegration}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/payment-method-details/:id"
          exact
          component={PaymentMethodDetails}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/cart-checkout"
          exact
          component={MainCheckout}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/shopping-cart"
          exact
          component={ShoppingCart}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/cart"
          exact
          component={CartScreen}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/book/:bookId/checkoutwithaddress"
          exact
          component={CheckoutWithAddressScreen}
          layout={MainLayout}
          requireAuthentication={true}
          authenticated={currentUser && currentUser.user ? true : false}
        />
        <RouteWithLayout
          path="/book/:bookId/checkoutEbook"
          exact
          component={CheckoutEbookScreen}
          layout={MainLayout}
          requireAuthentication={true}
          authenticated={currentUser && currentUser.user ? true : false}
        />
        <RouteWithLayout
          path="/book/:bookId/checkout"
          exact
          component={CheckoutScreen}
          layout={MainLayout}
          requireAuthentication={true}
          authenticated={currentUser && currentUser.user ? true : false}
        />
        <RouteWithLayout
          path="/pre-order"
          exact
          component={PreOrder}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/book/:bookId"
          exact
          component={BookScreen}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/author-book/:bookId"
          exact
          component={BookScreen}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/login"
          exact
          component={LoginScreen}
          layout={MinimalLayout}
        />
        <RouteWithLayout
          path="/register/:role"
          exact
          component={SignUpScreen}
          layout={MinimalLayout}
        />
        <RouteWithLayout
          path="/paper-jumpsuit"
          exact
          component={ArticlesScreen}
          layout={MainLayout}
        />
        <RouteWithLayout
          path="/kleverbooks"
          layout={MainLayout}
          exact
          component={BooksCatalog}
        />
        <RouteWithLayout
          path="/kleverbook/:bookId"
          exact
          component={AdverBook}
          layout={MainLayout}
        />
        <RouteWithLayout
            path="/verify-account/e-money/:token" // New route
            exact
            component={VerifyAccount}
            layout={MainLayout}
          />
          <RouteWithLayout
            path="/add-new-payment-method" // New route
            exact
            component={AddNewPaymentMethod}
            layout={MainLayout}
          />
        <RouteWithLayout
          path="/dashboard/:role"
          exact
          component={DashboardScreen}
          layout={MainLayout}
          requireAuthentication={true}
          authenticated={localStorage.getItem("Role")}
        />
        <RouteWithLayout
          path="/author/book/:bookId"
          layout={MainLayout}
          exact
          component={AuthorBookScreen}
          requireAuthentication={true}
          authenticated={currentUser && currentUser.author ? true : false}
        />
        <RouteWithLayout
          path="/author/add"
          layout={MainLayout}
          exact
          component={AddBookScreen}
          requireAuthentication={true}
          authenticated={currentUser && currentUser.author ? true : false}
        />
        <RouteWithLayout
          path="/loanbook/add"
          layout={MainLayout}
          exact
          component={LoanBooks}
          requireAuthentication={true}
          authenticated={currentUser && currentUser.author ? true : false}
        />

          <RouteWithLayout
            path="/author/add/d2pPublishing"
            layout={MainLayout}
            exact
            component={AddBookD2p}
            requireAuthentication={true}
            authenticated={currentUser && currentUser.author ? true : false}
          />
          <RouteWithLayout
            path="/book/:bookId/read"
            requireAuthentication={true}
            authenticated={currentUser && currentUser.user ? true : false}
            exact
            layout={MainLayout}
            component={ReadBookScreen}
          />
          <RouteWithLayout
            path="/article/:articleId/read"
            requireAuthentication={true}
            authenticated={currentUser && currentUser.user ? true : false}
            exact
            layout={MainLayout}
            component={ArticleReadScreen}
          />
          <RouteWithLayout
            path="/directory/:directoryId/article/:articleId/view"
            requireAuthentication={true}
            authenticated={currentUser && currentUser.user ? true : false}
            exact
            layout={MainLayout}
            component={ReadIndividualArticle}
          />
          <RouteWithLayout
            path="/kleverbook/read/:downloadId"
            requireAuthentication={true}
            authenticated={currentUser && currentUser.user ? true : false}
            exact
            layout={MainLayout}
            component={AdverBookRead}
          />
          <Redirect to="/" />
        </Switch>
      </BrowserRouter>
    </MyContextProvider>
  );
}

export default Routes;
